module.exports = __webpack_public_path__ + "static/media/75a-the-founding-of-prc-05.a743464c.png";